import React from 'react';
import styled from 'styled-components';
import { Color, Grid, Shadow, Type } from '../../../app/StyleGuide';
import { Container } from '../../../components/Layout';

const Banner = styled.div`
  margin: ${Grid._10} 0 0 0;
  border-top: 1px solid ${Color.Gray._20};
  background: ${Color.white};
  box-shadow: ${Shadow.large};
  color: ${Type.Color.dark};
`;

const Information = styled.div`
  display: flex;
  padding: ${Grid._8} ${Grid._5};
  h4 {
    text-transform: capitalize;
  }
  p {
    color: ${Type.Color.medium};
  }
  i {
    color: ${Color.Secondary._50};
    font-size: ${Type.Scale._6};
    margin-right: ${Grid._5};
  }
  a:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export default function BibleStudiesInformationBanner({ onShowOverlay }: { onShowOverlay: () => void }) {
  return (
    <>
      <Banner>
        <Container className="grid-container grid-sm-col-2">
          <Information>
            <div>
              <i className="fas fa-church"></i>
            </div>
            <div>
              <h4>How do digital curriculum subscriptions work?</h4>
              <p>Get started distributing, scheduling and managing curriculum for your church.</p>
              <a onClick={onShowOverlay}>Learn More</a>
            </div>
          </Information>
          <Information>
            <div>
              <i className="fas fa-concierge-bell"></i>
            </div>
            <div>
              <h4>We're here to answer your questions</h4>
              <p>
                You can get in touch with us via the chat icon in the lower right hand corner or view our help page.{' '}
              </p>
              <a
                href="https://support.ministrygrid.com/en/collections/2590229-digital-curriculum-on-ministry-grid"
                target="_blank"
                rel="noreferrer"
              >
                View FAQs
              </a>
            </div>
          </Information>
        </Container>
      </Banner>
    </>
  );
}
